import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AppService } from '../../services/app.service';

@Component({
  selector: 'app-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.sass']
})
export class LangSwitcherComponent {
  constructor(
    public appService: AppService,
    public translateService: TranslateService
  ) { }

  setLanguage(lang) {
    this.appService.setLanguage(lang);
    this.appService.setCulture(lang.toUpperCase());
  }
}
